import { render } from "./PasswordRecoveryForm.vue?vue&type=template&id=b307ef10&scoped=true"
import script from "./PasswordRecoveryForm.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryForm.vue?vue&type=script&lang=js"

import "./PasswordRecoveryForm.vue?vue&type=style&index=0&id=b307ef10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b307ef10"]])

export default __exports__